import { Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { SignatureProvider, SignatureProviderType } from '../../../../../services/signature/signature.objects';
import { SignatureService } from '../../../../../services/signature.service';
import { SignatureUtils } from '../../../../../services/signature.utils';
import { UIService } from '../../../../ui.service';
import { ConnectionSignStoreAdapter } from '../../../../_infrastructure/adapters/store/connection-sign/connection-sign.adapter';
import { take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})

export class SignatureResolver implements Resolve<{ providers: SignatureProvider[], availability: Map<SignatureProviderType, boolean> }> {
  private _isSignModuleAvailable: Map<SignatureProviderType, boolean>;
  private _enabledSignatureProviders: SignatureProvider[];

  constructor(
    private readonly _connectionSignStoreAdapter: ConnectionSignStoreAdapter,
    private _signatureService: SignatureService,
    private _translateService: TranslateService,
    private _signatureUtils: SignatureUtils,
    private _uiService: UIService
  ) { }

  resolve(): Observable<{
    providers: SignatureProvider[],
    availability: Map<SignatureProviderType, boolean>
  }> {
    this._loadSignatureProviders();

    return of({
      providers: this._enabledSignatureProviders,
      availability: this._isSignModuleAvailable,
    });
  }

  private _loadSignatureProviders(): void {
    this._isSignModuleAvailable = new Map();
    this._connectionSignStoreAdapter.selectConnectionStatus().pipe(take(1)).subscribe((status: boolean) => {
      if (!status) {
        this._enabledSignatureProviders = this._signatureUtils.getSignatureProviders().filter(provider =>
          this._signatureService.isSignatureProviderEnabled(provider.type)
        );
        this._checkSignatureProvider();
      }
    })
  }

  private _checkSignatureProvider(): void {
    this._enabledSignatureProviders.forEach((provider: SignatureProvider) => {
      if (provider && provider.type) {
        this._signatureService.check(
          () => this._checkSignatureSuccess(provider),
          () => this._checkSignatureError(provider),
          provider.type
        );
      }
    });
  }

  private _checkSignatureSuccess(provider: SignatureProvider): void {
    this._isSignModuleAvailable.set(provider.type, true);
  }

  private _checkSignatureError(provider: SignatureProvider): void {
    this._isSignModuleAvailable.set(provider.type, false);
    this._uiService.showMessage(
      this._translateService.instant('Signature.Error.Connection', {
        nombreApp: this._translateService.instant(provider.config?.btnName)
      }), 'Error', 'errorStyle', 'General.accept');
  }
}

